let host = window.location.hostname;
const ENV_BASE_API = (process.env.VUE_APP_BASE_API || '').trim();

const DEFAULT_BASE_API = (host === "localhost" || /^\d/.test(host))
    ? "https://api.heycharge.global"
    : host.includes("-test-qr.")
        ? "https://" + host.replace("-test-qr", "-test-api")
        : "https://api." + host.substring(host.indexOf('.') + 1);

const BASE_API = ENV_BASE_API || DEFAULT_BASE_API;

export { BASE_API };
